<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.REFUND.AGENT_APPROVAL' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
    <app-transit-request [IsAdminMode]="true" #transitRequest (TransitRequestObjValue)="receiveTransitValue($event)"
      (FeesEstimateObjValue)="receiveFeesValue($event)"></app-transit-request>
  </div>
  <br>

  <div *ngIf="baseRequestId" class="">
    <form #marineOffice [formGroup]="marineOfficeConfirmationForm">
      <fieldset [disabled]="true">
        <div class="form-container">

          <div class="form-section">
            <h4 class="section-title">{{'FRONT_USER.Marine_OFFICER_FORM.Marine_OFFICER_Confirmation' | translate }}</h4>

            <div class="form-group">
              <label for="Arrived">{{ 'FRONT_USER.Marine_OFFICER_FORM.VESSEL_ARRIVAL' | translate}}</label>
              <span class="red"> *</span>
              <div class="custom-checkbox">
                <input type="checkbox" checked="true" formControlName="Arrived" name="Arrived" id="Arrived"
                  (change)="onArrivedChange($event)">
                <label for="Arrived">{{ 'FRONT_USER.MARINE_CONFIRM_TRANSIT_FORM.MARINE_VESSEL_ACCEPT' |
                  translate}}</label>
              </div>
              <div *ngIf="submitted && form.Arrived?.errors" class="red ">
                <div *ngIf="form.Arrived?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="form-section" *ngIf="isArrived">


            <div class="form-group">
              <label for="ETA">{{'FRONT_USER.MARINE_CONFIRM_TRANSIT_FORM.ARRIVAL_DATE_TIME' | translate }}</label>
              <span class="red"> *</span>


              <style>
                input.form-control.bs-timepicker-field {
                  pointer-events: auto !important;
                }
              </style>


              <input class="form-control" #datepickerYMD="bsDatepicker" [bsValue]="bsValue" bsDatepicker
                formControlName="ETA">
              <timepicker id="ETATime" [readonlyInput]="false" formControlName="ETATime" [disabled]="false"
                [showMeridian]="false" [hourStep]="1" [minuteStep]="1"></timepicker>
              <div *ngIf="submitted &&form.ETA?.errors" class="red ">
                <div *ngIf="form.ETA?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="form.ETA?.errors?.pattern">
                  {{'FRONT_USER.Limit_Time_Rate' | translate}}
                </div>
              </div>


            </div>

            <div class="form-group">
              <label for="TimeRate">{{ 'FRONT_USER.MARINE_CONFIRM_TRANSIT_FORM.After_Limit_Time_Rate' |
                translate}}</label>
              <span class="red"> *</span>
              <div class="input-group">

                <input type="text" name="TimeRate" id="TimeRate" class="form-control" formControlName="TimeRate" />
                <span class="input-group-addon">%</span>

              </div>
              <div *ngIf="submitted &&form.TimeRate?.errors" class="red ">
                <div *ngIf="form.TimeRate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="form.TimeRate?.errors?.pattern">
                  {{'FRONT_USER.Limit_Time_Rate' | translate}}
                </div>
              </div>

            </div>
          </div>


        </div>



      </fieldset>
    </form>
  </div>


  <div *ngIf="baseRequestId" class="">
    <form #marineOffice [formGroup]="agentForm">
      <fieldset [disabled]="formMode != FormMode.Add">
        <div class="form-container">

          <div class="form-section">
            <h4 class="section-title">{{'ADMIN_USER.REFUND.AGENT_APPROVAL' | translate }}</h4>
            <div class="form-group">
              <label for="Decision">{{'ADMIN_USER.REFUND.DECISION' | translate}}</label>
              <span class="red">*</span>
              <div class="form-custom-inputs">
                <div *ngFor="let decisions of decisionKeys;let i='index'" class=" custom-Radio">
                  <input type="radio" [id]=[decisions] (change)="changeDecision(decision[decisions])"  name="Decision"
                    [value]="decision[decisions]" formControlName="Decision" />
                  <label [for]="[decisions]">{{ 'ADMIN_USER.REFUND.AgentApprovalActions.' + decisions | translate
                    }}</label>
                </div>
              </div>
              <div *ngIf="submitted && form1.Decision?.errors" class="red">
                <div *ngIf="form1.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              </div>
            </div>
          </div>
          <div *ngIf="decisionValue == decision.Reject && isPaid" class="form-group">

            <label>{{'FRONT_USER.AgentApproval.feesAlreadyPaid' | translate }}</label>


            <span class="red"> *</span>
            <div class="custom-checkbox">
              <input type="checkbox" checked="true" formControlName="PayFees" name="PayFees" id="PayFees">
              <label for="PayFees">{{ 'FRONT_USER.AgentApproval.Refund' |
                translate}}</label>
            </div>
            <div *ngIf="submitted && form1.PayFees?.errors" class="red ">
              <div *ngIf="form1.PayFees?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <div *ngIf="decisionValue == decision.Edit" class="form-group">
            <label for="TransitDate">{{'SHARED.REPORTS.EBOOKING_OBJECT_EXPORTING.TransitDate'| translate}}</label>
            <span class="red"> *</span>
            <input #TransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="TransitDate"
              [minDate]='minTransitDate' [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="TransitDate" class="form-control" name="TransitDate" />
              <div *ngIf="(submitted || form1.TransitDate?.dirty) && form1.TransitDate?.errors" class="red">
                <div *ngIf="form1.TransitDate?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="form1.TransitDate?.errors.sameAsCurrent">
                  {{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.SAME_AS_CURRENT_DATE' | translate}}
                </div>
              </div>


          </div>



        </div>


        <div class="form-container">
          <div *ngIf="formMode == FormMode.Add" class="form-group">
            <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
              'FRONT_USER.SUBMIT' | translate}}</button>
          </div>
        </div>

      </fieldset>
    </form>
  </div>



</div>
<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>